import type { ID } from "@constants";
import type { IFileObject, IOption, IStatus } from "@/interfaces";

export interface IMspGetAllEndpoint {
  id: ID;
  name: string;
  type: IOption;
  postal_code: string;
  timezone: IOption;
  contact_first_name: string;
  contact_last_name: string;
  address: string;
  country: IOption;
  state: IOption;
  city: IOption;
  phone: string;
  email: string;
  address_name: string;
  fax: string;
  website: string;
  lang: string;
  facility_id: string;
  assigned: boolean;
  mobile: string;
  status: IOption;
  msp_status: IOption<IStatus>;
}

export interface IMspGetEndpoint {
  id: ID;
  name: string;
  type: IOption;
  postal_code: string;
  timezone: IOption;
  contact_first_name: string;
  contact_last_name: string;
  address: string;
  description: string;
  country: IOption;
  state: IOption;
  city: IOption;
  phone: string;
  mobile: string;
  email: string;
  address_name: string;
  fax: string;
  website: string;
  lang: string;
  facility_id: ID;
  assigned: boolean;
  status: IOption;
  avatar: IFileObject;
  lat?: number;
  long?: number;
  map_address?: string;
}

export interface IMspDto {
  type: ID;
  name: string;
  mobile: string;
  phone: string;
  email: string;
  fax: string;
  first_name: string;
  last_name: string;
  website: string;
  description: string;
  avatar: ID | undefined;
  city_id: ID;
  postal_code: string;
  address: string;
  lat?: number;
  long?: number;
  map_address?: string;
}

export enum IMspTypeEnum {
  Drugstore = "drugstore",
  ImagingCenter = "imaging_center",
  Laboratory = "labratory",
}
